import { ExtractPropTypes, PropType } from 'vue'

export const calendarProps = {
  // v-model 等价于 modelValue 加上 update:modelValue
  modelValue: {
    type: Date
  },
  range: {
    type: Array as any as PropType<[Date, Date]>
  }
} as const

export type CalendarProps = Partial<ExtractPropTypes<typeof calendarProps>>

export const calendarEmits = {
  'update:modelValue': (val: Date) => val instanceof Date
}

export type CalendarEmits = typeof calendarEmits

export type CalendarDateCellType = 'prev' | 'current' | 'next'
export type CalendarDateCell = {
  text: number
  type: CalendarDateCellType
}

export type CalendarDateType =
  | 'prev-month'
  | 'prev-year'
  | 'today'
  | 'next-month'
  | 'next-year'
